import { connect } from 'react-redux';
import { broadCastActions } from 'Actions';
import ManageBroadcast from 'Components/Broadcast/Manage';

function mapStatetoProps(state){
    console.log('statestate -- ', state);
    const { exportBroadcastData } = state.exportBroadcastData;
    const { profile } = state
    return {
        profile:profile.permission && JSON.parse(profile.permission),
        ...state.broadCast,
        exportBroadcastData,
    }
}

const mapDispatchtoProps = {
    fetchBroadCast: broadCastActions.fetchBroadCast,
    deleteBroadCast: broadCastActions.deleteBroadCast,
    exportBroadcast: broadCastActions.exportBroadcast,
}

export default connect(mapStatetoProps,mapDispatchtoProps)(ManageBroadcast);